import React from "react";
import MemberInactiveList from "../Member/MemberInactiveList";

const AdminInactiveMembersPage: React.FC = () => {
  return (
    <div className="w-full">
      <div className="w-full h-[74px] p-4">
        <div className="mx-1 flex items-end">
          <div className="flex flex-1">
            <h1 className="text-gray-900 font-bold text-4xl">
              Manage Inactive Members
            </h1>
          </div>
        </div>
      </div>
      <MemberInactiveList />
    </div>
  );
};

export default AdminInactiveMembersPage;
